import WebServiceRequestForBlog from "@/libs/Api/WebServiceRequestForBlog";

class CreateABlog extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
    super.setTag("Blog/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllBlogs extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
      super.setMethod('GET')
    super.setTag("Blog/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleBlog extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
        super.setMethod('GET')
  }
  setRequestParam(id) {
    super.setTag(`Blog/GetBy/GetBy/${id}`);
  }
}

class UpdateABlog extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
    super.setMethod('PUT')
    super.setTag("Blog/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteABlog extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
      super.setTag("Blog/Delete");
      super.setMethod("DELETE");
  }

    setRequestParam(params) {
        super.setRequestParam(params);
  }
}

class UploaderForBlog extends WebServiceRequestForBlog {
    constructor(context) {
        super(context);
        super.setTag("Uploaders/Upload");
    }

    setFormData(data) {
        super.setFormData(data);
    }
}

class DeleteMediaForBlog extends WebServiceRequestForBlog {
    constructor(context) {
        super(context);
        super.setMethod("DELETE");
    }

    setParams(id) {
        super.setTag(`Uploaders/Delete/${id}`);
    }

    setSecretKey(params) {
        super.setRequestParam(params);
    }
}

export {CreateABlog, GetAllBlogs, GetASingleBlog, UpdateABlog, DeleteABlog, UploaderForBlog, DeleteMediaForBlog};
